/** Selected by the portal entry point before Pinia or the router starts. */
export type AuthMode = 'legacy' | 'portal-identity'

let mode: AuthMode = 'legacy'

export function configureAuthMode(next: AuthMode): void {
  mode = next
}

export function authMode(): AuthMode {
  return mode
}

export function isPortalIdentityMode(): boolean {
  return mode === 'portal-identity'
}
